function getBundleDiscount(price, quantity) {
  let totalOriginalPrice = price;
  let discountedPrice = 0;

  if (quantity >= 1 && quantity < window.theme.discountOffers[0][0]) {
    discountedPrice = totalOriginalPrice; // No discount
  } else {
    for (let i = 0; i < window.theme.discountOffers.length; i++) {
      let treshold = window.theme.discountOffers[i][0];
      let nextTreshold = 9999;
      
      if ((i + 1) < window.theme.discountOffers.length) {
        nextTreshold = window.theme.discountOffers[i + 1][0];
      }
      
      if (quantity >= treshold && quantity < nextTreshold) {
        let multiplicator = (100 - window.theme.discountOffers[i][1]) / 100;
        discountedPrice = totalOriginalPrice * multiplicator;
      }
    }
  }

  discountedPrice = totalOriginalPrice - discountedPrice;
  let discountPercentage = 100 - ((totalOriginalPrice - discountedPrice) / totalOriginalPrice) * 100;

  return {
    discountedPrice: discountedPrice,
    discountPercentage: discountPercentage,
  };
}

/**
 *
 * @returns Price in string format
 * @example 1000 -> 10.00 €
 */
function stringifyPrice(price) {
  //Broadcast created a theme object that extends the window and it create a TS error.
  //@ts-ignore
  return (price / 100).toFixed(2) + ' ' + window.theme.moneyFormat.replace('{{amount}}', '').replace('{{amount_with_comma_separator}}', '');
}

function stringifyPercentage(percentage) {
  return `${percentage}%`;
}

function stringifyDiscountedPercentage(percentage) {
  return `- ${percentage}%`;
}

function addListenerToElement(element, event, callback) {
  element?.addEventListener(event, callback);
}

function addListenersToElements(elements, eventname, callback) {
  elements.forEach((element) => {
    element.addEventListener(eventname, callback);
  });
}

function isReduction(price, comparePrice) {
  if (comparePrice === null || comparePrice === undefined) return false;
  return price < comparePrice;
}

function percentageByQuantity(quantity) {
  let discountPercentage = 0;
  let rest = 1;
  if (quantity >= 1 && quantity < window.theme.discountOffers[0][0]) {
    discountPercentage = 0;
    rest = 100;
  } else {
    for (let i = 0; i < window.theme.discountOffers.length; i++) {
      let treshold = window.theme.discountOffers[i][0];
      let nextTreshold = 9999;
      
      if ((i + 1) < window.theme.discountOffers.length) {
        nextTreshold = window.theme.discountOffers[i + 1][0];
      }
      
      if (quantity >= treshold && quantity < nextTreshold) {
        discountPercentage = window.theme.discountOffers[i][1];
        rest = 100 - discountPercentage;
      }
    }
  }
  return { rest, discountPercentage };
}

function percentagePriceAndCompare(price, comparePrice) {
  return Math.round(((comparePrice - price) / comparePrice) * 100);
}

function percentagePriceAndCompareAndQuantity(variant, quantity) {
  const isDiscount = isReduction(variant.price, variant.compare_at_price);
  // must use the variant prices from api because the product page prices get the pack discount
  const percentagePriceAndComparePrice = percentagePriceAndCompare(variant.price, variant.compare_at_price);
  const { discountPercentage } = percentageByQuantity(quantity);

  let compareAtPrice = variant.compare_at_price;
  let pourcentage = ((compareAtPrice - variant.price * ((100 - discountPercentage) / 100)) / compareAtPrice) * 100;

  let percentage = isDiscount ? pourcentage : percentagePriceAndComparePrice;

  return parseInt(percentage.toFixed(2));
}
